export default __webpack_public_path__ + "static/media/x-circle.827b33c2.svg";